import { apolloProvider } from '@/modules/GraphQL';
import { DISCOVERY_MATERIAL } from '@/graphql/discovery';
import { bizmatesApi } from '@/utils/bizmatesApi';

import logger from '@/modules/Logger';
import store from '@/store';

export const DiscoveryMaterialService = {
  new: async (lessonId) => {
    logger.info(`[Materials][Discovery] Fetched discovery article from new GraphQL endpoint`, {
      operation: 'materials:get'
    });

    const client = apolloProvider.defaultClient;
    const { data } = await client.query({
      query: DISCOVERY_MATERIAL,
      variables: {
        student_book_id: parseInt(lessonId)
      }
    });

    if (data?.discovery_article) {
      store.commit('material/setHtmlContent', data.discovery_article);
    } else {
      logger.error(`[Materials][discovery] Empty result from discovery article material api`, {
        operation: 'materials:get',
        event_type: 4,
        lesson_id: lessonId
      });
    }
  },

  legacy: async (lessonId) => {
    logger.info(`[Materials][Discovery] Fetched discovery article from legacy endpoint`, {
      operation: 'materials:get'
    });

    await bizmatesApi.get(`discovery/article.json?b=${lessonId}`, {}, (response) => {
      store.commit('material/setHtmlContent', response.data);
    });
  }
};
